const _LOCAL_STORAGE_KEY = 'recentGames'
const _MAX_GAMES = 15

const getRecentGames = () => {
  const recentGames = localStorage.getItem(_LOCAL_STORAGE_KEY)
  if (!recentGames) {
    return []
  }
  const recentParsed = JSON.parse(recentGames)
  // TODO: remove eventually
  const fixedGames = fixFormatting(recentParsed)
  if (JSON.stringify(fixedGames) !== recentGames) {
    localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(fixedGames))
    return fixedGames
  } else {
  }
  return recentParsed
}

// upper + 32 == lower
// converts from camelCase to snake_case
const fixFormatting = (recentGames) => {
  const updated = recentGames.map(rg => {
    const newObj = {}
    Object.keys(rg).forEach(key => {
      const val = rg[key]
      let newKey = ''
      key.split('').forEach((char, idx) => {
        if (char.match(/[A-Z]/)) {
          const charCode = char.charCodeAt() + 32
          newKey += `_${String.fromCharCode(charCode)}`
        } else {
          newKey += char
        }
      })
      newObj[newKey] = val
    })
    return newObj
  })
  return updated
}

const addRecentGame = (game) => {
  const recentGames = getRecentGames()
  const formattedGame = {
    ...game,
    last_played_at: new Date().toISOString(),
  }
  const existingGameIndex = recentGames.findIndex(g => g.short_id === formattedGame.short_id)
  if (existingGameIndex > -1) {
    recentGames.splice(existingGameIndex, 1)
  }
  if (recentGames.length >= _MAX_GAMES) {
    recentGames.pop()
  }
  const newRecentGames = [formattedGame, ...recentGames]
  localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(newRecentGames))
}

const getCachedGame = (shortId) => {
  const recentGames = getRecentGames()
  return recentGames.find(g => g.short_id === shortId)
}

export { getRecentGames, addRecentGame, getCachedGame }
